import React, {useContext, useEffect, useState} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {TextField, FormHelperText, Button, MenuItem} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchAllCompanyName,
  getServiceClientDetails,
  postCompanyInfo,
  resetToast,
} from '../../redux/reducers/clientMangement/Organizaation';
import PageLoader from '../../components/PageLoader';
import {submissionStart} from '../../redux/reducers/CommonActions/commonActions';
import {TENANTS_REVONE_COMPANIES} from '../../constants/ReusableConstants';
import {ThemeContext} from '../../themes/ThemeProvider';

const AddCompanyForm = ({
  setOpen = () => {},
  edit,
  tableData,
  siteTableData,
  handleDirty,
  organizationAccess,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [codePopover, setCodePopover] = useState(false);
  const [reportCodesData, setReportCodesData] = useState();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const dispatch = useDispatch();
  const {
    status,
    isLoading,
    successMsg,
    errorMsg,
    serviceClientInfo: companyInfo,
    allCompanyNames,
  } = useSelector(({organization}) => organization);
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetToast());
      }, 3000);
    }
  }, [successMsg, errorMsg]);

  useEffect(() => {
    dispatch(fetchAllCompanyName());
  }, []);

  useEffect(() => {
    if (successMsg && companyInfo?.companyId) {
      dispatch(getServiceClientDetails(companyInfo?.companyId, 'Company'));
    }
  }, [successMsg, companyInfo?.companyId]);

  const editTableData =
    allCompanyNames?.length > 0 ?
      allCompanyNames?.filter(
        (el) =>
          el.companyName?.toLowerCase()?.trim() !==
            companyInfo?.companyName?.toLowerCase()?.trim(),
      ) :
      [];

  const companyTableData = (type) => {
    const clientData =
      // Array.isArray(tableData) &&
      // tableData.map((item) => {
      //   return item[type];
      // });
      tableData?.length > 0 ?
        tableData.map((item) => {
          return item[type];
        }) :
        editTableData?.length > 0 ?
          editTableData.map((item) => {
            return item[type];
          }) :
          [];
    return clientData;
  };

  const companyNameData = (data) => {
    const clientData =
      tableData?.length > 0 ? allCompanyNames : allCompanyNames?.length > 0 ? editTableData : [];
    return clientData;
  };

  const checkCompanyExist = (value, type) => {
    if (companyNameData(allCompanyNames) && companyNameData(allCompanyNames)?.length > 0 && value) {
      const titleData = [];
      companyNameData(allCompanyNames)?.filter((i) => {
        if (
          i?.companyName?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          titleData.push(i);
        }
      });
      return titleData.length > 0;
    } else {
      return false;
    }
  };

  const checkGroupCodeAlreadyExist = (value) => {
    if (companyNameData(allCompanyNames) && companyNameData(allCompanyNames)?.length > 0 && value) {
      const ar = [];
      companyNameData(allCompanyNames)?.filter((i) => {
        if (
          i?.companyName?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const getCompanyCodesData = () => {
    if (companyTableData('companyName') && companyTableData('companyName')?.length > 0) {
      return companyTableData('companyName')?.filter((i) =>
        i?.toLowerCase()?.trim().startsWith(reportCodesData?.toLowerCase()?.trim()),
      );
    } else {
      return [];
    }
  };

  const validationSchema = Yup.object().shape({
    companyName: Yup.string()
      .required(`${TENANTS_REVONE_COMPANIES} Name is required`)
      .test(
        'companyName',
            `${TENANTS_REVONE_COMPANIES} Name already exists`,
            (value) => !checkCompanyExist(value, 'companyName'),
      )
      .trim()
      .test(
        'companyName',
            `${TENANTS_REVONE_COMPANIES} Name has already been used in the past`,
            (value) => !checkGroupCodeAlreadyExist(value),
      ),
  });

  const initialVal = {
    companyName: companyInfo?.companyName || '',
  };
  const handleSubmit = (values) => {
    if (values) {
      dispatch(submissionStart());
      const data = {
        companyId: companyInfo?.companyId || 0,
        companyName: values?.companyName ? values?.companyName : '',
      };
      dispatch(postCompanyInfo(data));
    }
    handleDirty(false, 'fixed');
  };

  useEffect(() => {
    if (status === 200) {
      setOpen(false);
    }
  }, [status]);

  window.onclick = function() {
    setCodePopover(false);
  };

  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            resetForm,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <div className="col-12">
              <div className="new-standard-textfields">
                <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="col-sm-8 col-md-6 col-xl-4 form-group pl-0">
                      <TextField
                        className={` ${classes.labelName}`}
                        margin="dense"
                        variant="outlined"
                        label={`${TENANTS_REVONE_COMPANIES} Name`}
                        placeholder={`Select ${TENANTS_REVONE_COMPANIES} Name`}
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        name="companyName"
                        required
                        value={values?.companyName}
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue('companyName', e.target.value);
                          if (e.target.value) {
                            setCodePopover(true);
                            setReportCodesData(e.target.value);
                          } else if (e.target.value === '') {
                            setCodePopover(false);
                          }
                        }}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.companyName}
                        error={Boolean(touched.companyName && errors.companyName)}
                      />
                      <FormHelperText>
                        {touched.companyName && errors?.companyName && errors.companyName}
                      </FormHelperText>
                      <div className="windowcode-popover Add-trigger-group-popover">
                        {codePopover &&
                          getCompanyCodesData()?.map((data, i) => (
                            <MenuItem key={i}>{data}</MenuItem>
                          ))}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      variant="outlined"
                      className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      onClick={() => {
                        resetForm();
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="outlined"
                      type="submit"
                      disabled={(edit && !organizationAccess?.edit) || enabledSubmission}
                      className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                    >
                      Save
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
    </>
  );
};

export default AddCompanyForm;
